import { RegisterScreen } from '@/screens/auth/register-screen';
export default RegisterScreen;
